import { BlastRadiusOrg } from '../types'
import LevelPill from '../../../components/badges/LevelPill'

interface Props {
    orgs: BlastRadiusOrg[]
    moreText?: string // e.g. "+ 5 more organisations · 73 profiles"
}

export default function BlastRadiusTree({ orgs, moreText }: Props) {
    return (
        <div className="rounded-lg border border-gray-200">
            {orgs.map((org) => (
                <div key={org.name} className="border-b border-gray-100 last:border-b-0">
                    <div className="flex items-center gap-2 px-3 py-2">
                        <LevelPill level={org.level} />
                        <span className="font-semibold text-gray-900">{org.name}</span>
                        <span className="ml-auto text-xs text-gray-500">
                            {org.teamCount} team{org.teamCount === 1 ? '' : 's'} · {org.profileCount} {org.profileCount === 1 ? 'profile' : 'profiles'}
                        </span>
                    </div>
                    {org.teams.map((team) => (
                        <div
                            key={team.name}
                            className="flex justify-between border-t border-dashed border-gray-100 px-3 py-1.5 pl-9 text-xs text-gray-600"
                        >
                            <span>{team.name}</span>
                            <span>{team.profileCount} {team.profileCount === 1 ? 'profile' : 'profiles'}</span>
                        </div>
                    ))}
                </div>
            ))}
            {moreText && <div className="px-3 py-2 text-xs text-gray-500">{moreText}</div>}
        </div>
    )
}
